<template>
    <div class="q-pa-lg" id="PrivacyPolicy">
        <img src="../assets/logo-old.png" style="width:10%;" class="d-block mx-auto">
        <h4 class="q-pb-sm" style="text-align: center">Privacy policy</h4>
        <p>AmityBizNet is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share your information when you use our application or services. By using our app, you agree to the practices outlined in this policy. It also describes the choices available to you regarding our use of your Personal Information and how you can access and update this information. This Policy does not apply to the practices of companies that we do not own or control, or to individuals that we do not employ or manage.</p>
        <h5>⁠Information We Collect</h5>
        <p>When you open the Mobile Application our servers automatically record information that your device sends. This data may include information such as your device's IP address and location, device name and version, operating system type and version, language preferences, information you search for in our Mobile Application, access times and dates, and other statistics.</p>
        <p>During Registration, We collect the following information to register and verify new users:</p>
        <p>
            <div>Company Name</div>
            <div>GSTIN (Goods and Services Tax Identification Number)</div>
            <div>spanAN (spanermanent Account Number)</div>
            <div>Address</div>
            <div>Mobile Number</div>
            <div>Email Address</div>
            <div></div>
        </p>
        <p>For Additional Verification, After registration, we may collect:
        </p>
        <p>
            <div>GSTIN Certificate (Image Upload)</div>
            <div>PAN Card Image (Image Upload)</div>
        </p>
        <p>This information is collected to verify your identity and ensure compliance with applicable laws.
        </p>

        <h5>Managing personal information</h5>
        <p>You are able to access, add to, update and delete certain Personal Information about you. The information you can view, update, and delete may change as the Mobile Application or Services change. When you update information, however, we may maintain a copy of the unrevised information in our records. Some information may remain in our private records after your deletion of such information from your account. We will retain and use your Personal Information for the period necessary to comply with our legal obligations, resolve disputes, and enforce our agreements unless a longer retention period is required or permitted by law. We may use any aggregated data derived from or incorporating your Personal Information after you update or delete it, but not in a manner that would identify you personally. Once the retention period expires, Personal Information shall be deleted. Therefore, the right to access, the right to erasure, the right to rectification and the right to data portability cannot be enforced after the expiration of the retention period.</p>


        <h5>How We Use Your Data</h5>
        <p>We collect and process your data for the following purposes:</p>
        <p>
            <div>Account Creation & Verification: To verify your business details and activate your account.</div>
            <div>Legal Compliance: To comply with GST regulations and other statutory requirements.</div>
            <div>Service Improvement: To enhance user experience and provide better services.</div>
            <div>Customer Support: To address your inquiries or complaints.</div>
        </p>


        <h5>How We Share Your Data</h5>
        <p>We do not sell or share your personal information with third parties, except in the following circumstances:
        </p>
        <p>
            <div>With Service Providers: To process your verification or provide our services (e.g., hosting services or analytics).</div>
            <div>Legal Requirements: To comply with legal obligations or government requests.</div>
            <div>Business Transfers: In case of a merger, acquisition, or sale of assets.</div>
        </p>

        <h5>Privacy of children</h5>
        <p>We do not knowingly collect any Personal Information from children under the age of 13. If you are under the age of 13, please do not submit any Personal Information through our Mobile Application or Service. We encourage parents and legal guardians to monitor their children's Internet usage and to help enforce this Policy by instructing their children never to provide Personal Information through our Mobile Application or Service without their permission. If you have reason to believe that a child under the age of 13 has provided Personal Information to us through our Mobile Application or Service, please contact us. You must also be old enough to consent to the processing of your Personal Information in your country (in some countries we may allow your parent or guardian to do so on your behalf).</p>

        <h5>Newsletters</h5>
        <p>We offer electronic newsletters to which you may voluntarily subscribe at any time. You may choose to stop receiving our newsletter or marketing emails by following the unsubscribe instructions included in these emails or by contacting us. However, you will continue to receive essential transactional emails.</p>

        <h5>Data Retention</h5>
        <p>We retain your data for as long as necessary to provide our services and comply with legal obligations. If you delete your account, we will delete your data except for information we are required to retain by law.</p>

        <h5>⁠Your Rights</h5>
        <p>You have the right to:</p>
        <p>
            <div>Access, update, or delete your data by contacting us at info@amityinfosoft.com</div>
            <div>Withdraw consent for data collection, though this may limit app functionality.</div>
        </p>

        <h5>Security</h5>
        <p>We implement industry-standard security measures to protect your data. However, no system is entirely secure, and we encourage you to contact us if you suspect unauthorized access to your account.</p>

        <h5>Changes to This Privacy Policy</h5>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated "Effective Date." Continued use of our app constitutes acceptance of the updated policy.</p>

        <h5>Acceptance of this policy</h5>
        <p>You acknowledge that you have read this Policy and agree to all its terms and conditions. By using the Mobile Application or its Services you agree to be bound by this Policy. If you do not agree to abide by the terms of this Policy, you are not authorized to use or access the Mobile Application and its Services.
        </p>

        <h5>Contact Us</h5>
        <p>If you have questions about this Privacy Policy, contact us at info@amityinfosoft.com</p>

        <p>This document was last updated on November 21, 2024</p>
        <footer  style="border-top: 1px solid lightgrey; ">
            <div class="row" style="align-items: center; padding-left: 25px; ">
                <div class="col-3">
                    <p class="mb-0 mt-1" style="color: grey; font-size: 12px;">Powered by</p>
                    <div class="footer-logo mb-2">
                        <a href="http://www.amitygroup.in/" target="_blank">
                            <img alt="" class="w-100 d-block mx-auto" src="../../src/assets/footer-logo.png">
                        </a>
                    </div>
                </div>
                <div class="col-6">
                    <p class="text-center mb-1" style="color: grey">For More Detail Contact Us on : 0261 6657000 I
                        <a href="" style="color: grey">support@amitybiz.net</a></p>
                    <p class="text-center mb-1" style="color: #959595; font-size: 12px;">Copyright &copy; 2019 Amity
                        Infosoft (P) Ltd., All rights reserved</p>
                </div>
                <div class="col-3">
                    <div class="d-flex" style="justify-content: flex-end;">
                        <div class="social-icons mx-2">
                            <a href="https://www.facebook.com/amityinfosoft" target="_blank"><i
                                    class="fab fa-facebook-f"></i></a>
                        </div>
                        <div class="social-icons mx-2">
                            <a href="https://www.linkedin.com/company/amityinfosoft" target="_blank"><i
                                    class="fab fa-linkedin-in"></i></a>
                        </div>
                        <div class="social-icons mx-2">
                            <a href="https://twitter.com/Amityinfosoft" target="_blank"><i
                                    class="fab fa-twitter"></i></a>
                        </div>
                        <div class="social-icons ml-2">
                            <a href="https://www.instagram.com/amityinfosoft/" target="_blank"><i
                                    class="fab fa-instagram"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
  export default {
    name: 'PrivacyPolicy',
  }
</script>

<style scoped>

</style>
